import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePermissions } from '@/hooks/usePermissions';
import { IOSLoadingSpinner } from './IOSLoadingSpinner';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading: authLoading } = useAuth();
  const { hasRole, loading: permissionsLoading } = usePermissions();

  if (authLoading || permissionsLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center ios-glass animate-fade-in">
        <div className="flex flex-col items-center gap-4">
          <IOSLoadingSpinner size="lg" />
          <p className="ios-caption animate-pulse">Checking permissions...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!hasRole(['admin', 'owner'])) {
    return <Navigate to="/dashboard" replace />;
  }

  return <div className="ios-page-transition">{children}</div>;
};
